const mapExhibitor = exhibitor => {
  return Object.assign({}, exhibitor, {
    filters:exhibitor.exhibitorFilters,
    name: exhibitor.exhibitorName,
    description: exhibitor.exhibitorDescription,
    features: exhibitor.exhibitorFeatures,
    representedBrands: exhibitor.representedBrands && exhibitor.representedBrands.map((value, i) => ({
      value,
      isMatch: exhibitor?._highlightResult?.representedBrands?.[i].matchLevel === 'full'
    }))
  })
};

const mapProduct = product =>{
  return Object.assign({}, product, {
    filters:product.productFilters,
    name: product.productName,
    features: product.productFeatures,
    exhibitingOrganisationName: product.exhibitorName
  })
}

const mapExhibitors = exhibitors => exhibitors.map(mapExhibitor);
const mapProducts = products => products.map(mapProduct);

export default { mapExhibitors, mapProducts };
